import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedArchivesComponent } from './shared-archives/shared-archives.component';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule, provideAnimations } from '@angular/platform-browser/animations';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { AccordionModule } from 'primeng/accordion';
import { SharedModule, ConfirmationService, MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { CarouselModule } from 'primeng/carousel';
import { CheckboxModule } from 'primeng/checkbox';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DataViewModule } from 'primeng/dataview';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { IconFieldModule } from 'primeng/iconfield';
import { ImageModule } from 'primeng/image';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputIconModule } from 'primeng/inputicon';
import { InputMaskModule } from 'primeng/inputmask';
import { InputOtpModule } from 'primeng/inputotp';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { MessageModule } from 'primeng/message';
import { MessagesModule } from 'primeng/messages';
import { MultiSelectModule } from 'primeng/multiselect';
import { PasswordModule } from 'primeng/password';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SkeletonModule } from 'primeng/skeleton';
import { TableModule } from 'primeng/table';
import { TabMenuModule } from 'primeng/tabmenu';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { TranslocoRootModule } from 'src/app/transloco-root.module';
import { DashboardTemplateComponent } from '../dashboard/dashboard-template/dashboard-template.component';

@NgModule({
    declarations: [
    SharedArchivesComponent,
  ],
  imports: [
      CommonModule,
      ProgressSpinnerModule,
      CarouselModule,
      ImageModule,
      ButtonModule,
      FormsModule,
      BrowserModule,
      BrowserAnimationsModule,
      AppRoutingModule,
      InputTextModule,
      InputGroupModule,
      InputGroupAddonModule,
      PasswordModule,
      MessagesModule,
      MessageModule,
      ReactiveFormsModule,
      DropdownModule,
      CalendarModule,
      InputMaskModule,
      SelectButtonModule,
      TranslocoRootModule,
      HttpClientModule,
      CheckboxModule,
      InputOtpModule,
      DashboardTemplateComponent,
      TabMenuModule,
      InputSwitchModule,
      TooltipModule,
      ToastModule,
      ConfirmDialogModule,
      TableModule,
      SharedModule,
      DialogModule,
      DataViewModule,
      SkeletonModule,
      InputIconModule,
      IconFieldModule,
      AccordionModule,
      MultiSelectModule
    ],
    providers: [provideAnimations(), provideAnimationsAsync(), ConfirmationService, MessageService]

})
export class ArchivesModule {

 }
